export const clearSessionStorage = (startsWith: string) => {
  Object.keys(sessionStorage)
    .filter((key) => key.startsWith(startsWith))
    .forEach((key) => sessionStorage.removeItem(key));
};
